import { useEffect, type ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '@/app/hooks'
import { fetchDealers } from '@/features/dealers/dealersSlice'
import { fetchPlans } from '@/features/plans/plansSlice'
import { fetchExceptions } from '@/features/exceptions/exceptionsSlice'
import { linkChecking } from '@/features/connection/connectionSlice'
import { TopNav } from './TopNav'

export function AppLayout(): ReactNode {
  const dispatch = useAppDispatch()
  const theme = useAppSelector((s) => s.ui.theme)
  const { cloudUrl, adminKey } = useAppSelector((s) => s.connection)

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark')
  }, [theme])

  // Load everything once per credential change. Dealers, plans and exceptions
  // are all small lists, and having plans in hand makes the dealer panel usable
  // the moment it opens.
  useEffect(() => {
    if (!cloudUrl || !adminKey) return
    dispatch(linkChecking())
    void dispatch(fetchDealers())
    void dispatch(fetchPlans())
    void dispatch(fetchExceptions())
  }, [dispatch, cloudUrl, adminKey])

  return (
    <div className="flex h-screen p-2 flex-col overflow-hidden bg-canvas">
      <TopNav />
      {/* Content sits in its own panel below the nav, same outline as the bar. */}
      <main className="scroll-slim mt-2 overflow-y-auto rounded-[8px] border border-line px-4 py-3 sm:px-6">
        <Outlet />
      </main>
    </div>
  )
}
